// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"3130":"css/app.7056","6030":"css/admin-app.7056"}[chunkId] + ".css";
};